import { keyframes, mergeStyles } from "@fluentui/react";
const shimmerAnimation = keyframes({
    "0%": { backgroundPosition: "-200% 0" },
    "100%": { backgroundPosition: "200% 0" },
});
/** Module-level constant — avoids recreating styles on every render */
export const recommendationInputStyles = {
    wrapper: mergeStyles({
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "16px 0",
        marginBottom: "8px",
        width: "100%",
    }),
    inputRow: mergeStyles({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        border: "1px solid #c8c6c4",
        borderRadius: "4px",
        padding: "6px 12px",
        backgroundColor: "#ffffff",
        transition: "border-color 0.2s ease",
        selectors: {
            "&:focus-within": {
                borderColor: "#0078d4",
                borderWidth: "2px",
                padding: "5px 11px",
            },
        },
    }),
    icon: mergeStyles({
        fontSize: "20px",
        color: "#0078d4",
        flexShrink: 0,
    }),
    input: mergeStyles({
        flex: 1,
        border: "none",
        outline: "none",
        fontSize: "14px",
        lineHeight: "20px",
        backgroundColor: "transparent",
        fontFamily: "inherit",
        selectors: {
            "::placeholder": {
                color: "#a19f9d",
            },
        },
    }),
    clearButton: mergeStyles({
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        color: "#605e5c",
        borderRadius: "2px",
        selectors: {
            ":hover": {
                color: "#323130",
                backgroundColor: "#f3f2f1",
            },
        },
    }),
    shimmer: mergeStyles({
        height: "3px",
        borderRadius: "2px",
        background: "linear-gradient(90deg, transparent 25%, #0078d4 50%, transparent 75%)",
        backgroundSize: "200% 100%",
        animationName: shimmerAnimation,
        animationDuration: "1.5s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
    }),
    statusText: mergeStyles({
        fontSize: "12px",
        color: "#605e5c",
        fontStyle: "italic",
    }),
    statusWarning: mergeStyles({
        fontSize: "12px",
        color: "#a4262c",
        fontStyle: "italic",
    }),
    disclaimer: mergeStyles({
        fontSize: "11px",
        color: "#605e5c",
        lineHeight: "16px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    }),
};
